export default campaignLandingCtrl

/** @ngInject */
function campaignLandingCtrl($scope, $stateParams, currentCampaign) {
    $scope.stateParams = $stateParams
    $scope.currentCampaign = currentCampaign
}



// WEBPACK FOOTER //
// ./src/states/campaignLanding/campaignLanding.js